<div class="tasks-tab">

    <div class="title">Maintenance Tasks</div>

    <!-- Email Channel Disabled Banner -->
    <div *ngIf="isEmailDisabled" class="alert alert-info margin-bottom-20" style="background-color: #d1ecf1; border-color: #bee5eb; color: #0c5460; padding: 12px; border-radius: 4px;">
        <i class="fa fa-info-circle"></i> Email channel has been disabled.
    </div>

    <form [formGroup]="formGroup">

        <!-- Task Updates -->
        <div class="row notify-group">

            <div class="task-icon-container col-md-1">
                <i class="fa-regular fa-bell fa-2x"></i>
            </div>

            <div class="col-md-10">

                <div class="row">
                    <div class="col-md-12">
                        <div class="font-bold margin-top-5">Maintenance Task Updates</div>
                        <div class="margin-top-5">Notifications about when teammates add, modify, or remove maintenance tasks.</div>
                    </div>
                </div>

                <!-- <div class="channel-inline-container margin-top-24">
                    <div style="margin-right: 8px;">Channel</div>
                    <select class="sp-select form-control" disabled>
                        <option value="Email">Email</option>
                    </select>
                </div> -->
                    
            </div>

            <div class="col-md-1">
                <dx-switch formControlName="taskUpdatesSwitch" [value]="true" [width]="50" [switchedOnText]="''"
                    [switchedOffText]="''" 
                    [disabled]="isEmailDisabled"
                    (onValueChanged)="onTaskUpdatesSwitchChanged($event)">
                </dx-switch>
            </div>
        </div>

        <!-- Photos and Files -->
        <div class="row notify-group">
            <div class="task-icon-container col-md-1">
                <i class="fa-regular fa-image fa-2x"></i>
            </div>

            <div class="col-md-10">
                <div class="row">
                    <div class="col-md-12">
                        <div class="font-bold margin-top-5">Photos and Files</div>
                        <div style="font-size: 14px;">
                            Notifications when teammates add, modify, or remove photos and files for a maintenance task.
                        </div>
                    </div>
                </div>

                <!-- <div class="channel-inline-container margin-top-24">
                    <div style="margin-right: 8px;">Channel</div>
                    <select class="sp-select form-control" disabled>
                        <option value="Email">Email</option>
                    </select>
                </div> -->
                    
            </div>

            <div class="col-md-1">
                <dx-switch formControlName="taskPhotosFilesSwitch" [value]="true" [width]="50" [switchedOnText]="''"
                    [switchedOffText]="''" 
                    [disabled]="isEmailDisabled"
                    (onValueChanged)="onTaskPhotosFilesSwitchChanged($event)">
                </dx-switch>
            </div>
        </div>

        <!-- Notes -->
        <div class="row notify-group">
            <div class="task-icon-container col-md-1">
                <i class="fa-regular fa-note-sticky fa-2x"></i>
            </div>

            <div class="col-md-10">
                <div class="row">
                    <div class="col-md-12">
                        <div class="font-bold margin-top-5">Notes</div>
                        <div class="margin-top-5">
                            Notifications when teammates add, modify, or remove notes for a maintenance task.
                        </div>
                    </div>
                </div>

                <!-- <div class="channel-inline-container margin-top-24">
                    <div style="margin-right: 8px;">Channel</div>
                    <select class="sp-select form-control" disabled>
                        <option value="Email">Email</option>
                    </select>
                </div> -->
                   
            </div>

            <div class="col-md-1">
                <dx-switch formControlName="taskNotesSwitch" [value]="true" [width]="50" [switchedOnText]="''"
                    [switchedOffText]="''" 
                    [disabled]="isEmailDisabled"
                    (onValueChanged)="onTaskNotesSwitchChanged($event)">
                </dx-switch>
            </div>
        </div>
    </form>

</div>